import React, { Component } from 'react';
import DocFwb from './DocFwb';
import http from '../../../utils/http';

class DocFwbContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAllowed: false,
      loading: true,
    };
  }

  componentDidMount() {
    http
      .get('/settings?key=doc_fwb')
      .then(({ data }) => {
        if (data.data) {
          const config = data.data.find((item) => item.key === 'doc_fwb');
          if (config?.value && config.value?.data === 'true') {
            this.setState({
              isAllowed: true,
              loading: false 
            });
            return;
          }
        }
        this.props.history.push('/redirect');
      })
      .catch(() => {
        this.props.history.push('/redirect');
      });
  }

  render() {
    if (this.state.loading || !this.state.isAllowed) {
      return null;
    }
    return <DocFwb {...this.props} />;
  }
}

export default DocFwbContainer;
